// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';
import { create } from 'yup/lib/Reference';

export const getGeoLocation = createAsyncThunk('geoLocationSliceData/getGeoLocation', async () => {
    try {
        let response = await axios.get('/GeoLocation', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getGeoLocationOptions = createAsyncThunk('geoLocationSliceData/getGeoLocationOptions', async () => {
    try {
        let response = await axios.get('/GeoLocation?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
//fetch employees for bulk assign modal
export const getEmployee = createAsyncThunk('rulesLeaveRuleSlice/getEmployee', async () => {
    try {
        let response = await axios.get('/Employee', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
         
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getGeoLocationStatus = createAsyncThunk('geoLocationSliceData/getGeoLocationStatus', async () => {
    try {
        let response = await axios.get('/GeoLocation?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteGeoLocation = createAsyncThunk('geoLocationSliceData/deleteGeoLocation', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/GeoLocation/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'FaqCategory deleted successfully.');
        await dispatch(getGeoLocation());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createGeoLocation = createAsyncThunk('geoLocationSliceData/createGeoLocation', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/GeoLocation', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'FaqCategory added succesfully.');
        await dispatch(getGeoLocation());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateGeoLocation = createAsyncThunk('geoLocationSliceData/updateGeoLocation', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/GeoLocation/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'GeoLocation updated succesfully.');
        await dispatch(getGeoLocation());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateGeoLocationStatus = createAsyncThunk('geoLocationSliceData/updateGeoLocationStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put(
            '/GeoLocation/status/' + id,
            {},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        toast.success(response?.data?.message || 'Status Updated Successfully');
        await dispatch(getGeoLocation());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const bulkAssignLocation = createAsyncThunk('geoLocationSliceData/bulkAssignLocation', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/GeoLocation/assign-location', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Locations assigned successfully');
        await dispatch(getGeoLocation());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getAssignedGeoLocationEmployees = createAsyncThunk('geoLocationSliceData/getAssignedGeoLocationEmployees', async (id) => {
    try {
        let response = await axios.get('/GeoLocation/assigned-employee/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const geoLocationSlice = createSlice({
    name: 'geoLocationSliceData',
    initialState: {
        geoLocation: [],
        geoLocationStatus: [],
        geoLocationOptions: [],
        employeeList: []
    },
    extraReducers: (builder) => {
        builder.addCase(getGeoLocation.fulfilled, (state, action) => {
            state.geoLocation = action?.payload;
            return;
        });
        builder.addCase(getGeoLocationStatus.fulfilled, (state, action) => {
            state.geoLocationStatus = action?.payload;
            return;
        });
        builder.addCase(getGeoLocationOptions.fulfilled, (state, action) => {
            state.geoLocationOptions = action?.payload;
            return;
        });
        builder.addCase(getEmployee.fulfilled, (state, action) => {
            state.employeeList = action?.payload;
            return; 
        });
    }
});

export default geoLocationSlice.reducer;
